import React from "react";
import type { FC } from 'react';
import './currencyStyles.css'
import {Typography } from "@mui/material";

interface NDollarSymbolProps {
  [key: string]: any;
}

const NDollarSymbol: FC<NDollarSymbolProps> = (props) => {
  return (
    <h1
      // component="div"
      // sx={{
      //   fontSize: {
      //     lg: '2rem',
      //     md: '1.5rem',
      //     sm: '1rem',
      //     xs: '1rem'
      //   },
      //   fontWeight: 'bold'
      // }}
    >
      N$
    </h1>
  );
};

export default NDollarSymbol;